<div editPanel>
  @for (param of cfg?.form?.params; track $index) {
    @switch (param.type) {
      @case (2) {
        <mat-form-field class="full" subscriptSizing="dynamic">
          <mat-label>{{ param.title }}</mat-label>
          <input [(ngModel)]="param.stringValue" matInput type="text">
          @if (!Utils.isEmpty(globals.siteConfig.pdfData.name)) {
            <button (click)="param.stringValue=''" aria-label="Clear" mat-icon-button matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      }
      @case (3) {
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>{{ param.title }}</mat-label>
          <input [(ngModel)]="param.intValue" [max]="19" [min]="1" matInput type="number">
        </mat-form-field>
      }
      @default () {
        Parametertyp {{ param.type }} unknown
      }
    }
  }
  <color-cfg [colorKey]="'main'"></color-cfg>
  <div filler></div>
</div>
<!-- div edit>
  <textarea [(ngModel)]="text" editor></textarea>
</div -->
<button (click)="clickCreate()">
  <mat-icon>arrow_right</mat-icon>
</button>
<div show>
  <iframe id="pdf" pdf></iframe>
</div>
